// extracted by mini-css-extract-plugin
module.exports =  {"container":"PDCcSsK1agcHB6Io0jUb"};